import { Component, ViewEncapsulation } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Header } from 'src/app/shared/components/header/header.model';
import { DataService } from '../../../core/data.service';
import * as FileSaver from 'file-saver';
import { UploadService } from '../../../shared/services/upload.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { mergeMap, tap } from 'rxjs/operators';



@Component({
  selector: 'app-broad-cast',
  templateUrl: './broadcast-details.component.html',
  styleUrls: ['./broadcast-details.component.scss'],
})
export class BroadcastDetailsComponent {

  jsonData: any = {

    Head_Label6: 'AGM Agenda 2019.pdf',
  };

  title = 'kpmg-advent';
  headerData: Header = new Header();
  id: any;
  broadcastDetails: any = [];
  broadcastProxyDetails: any = [];
  showProxyButton: boolean = false;
  detes: any;
  originalFiles: any = [];
  readfile: any = [];
  recepientFiles: any = [];
  iconList: any = [];
  getFileExtension: any;
  creditorId: any;
  userId:any;
  isnotonlyPDF:string;
  isLoading:boolean = true;
  particularsOfDebtId:string;
  creditorName:string;
  constructor(private spinnerService: NgxSpinnerService,
    private dataService: DataService, private uploadService: UploadService, private activatedRoute: ActivatedRoute,
    private router:Router) {
    this.spinnerService.show();
    this.headerData.isHeaderRight = true;
    this.headerData.className = "broad-cast";
  }
  ngOnInit() {
    this.id = sessionStorage.getItem('broadcastId');
    this.creditorId = this.activatedRoute.snapshot.paramMap.get('creditorId');
    this.particularsOfDebtId = this.activatedRoute.snapshot.paramMap.get('podId');
    this.creditorName = this.activatedRoute.snapshot.paramMap.get('creditorName');
    this.userId = sessionStorage.getItem('userId');
    this.getBroadcastDetailsById();
    
    
  }
  
getBroadcastDetailsById() {
  const path = `broadcasts/broadcastdetailbyid?id=${this.id}&creditorId=${this.creditorId}&userId=${this.userId}`;

  this.spinnerService.show();
  this.dataService.getRequest(path).pipe(
    mergeMap((broadcastResponse: any) => {
      if (broadcastResponse.hasPermissiontoView) {
        this.broadcastDetails = broadcastResponse;
        this.broadcastDetails.publishDateTime = moment(this.broadcastDetails.publishDateTime).format("DD-MMM-yyyy, h:mma") + " GMT+8";
        this.listofDocuments();

        // Prepare second API call path
        const secondPath = `broadcasts/broadcastnamepublishdatebyid?engagementId=${broadcastResponse.engagementId}&creditorId=${this.creditorId}&isView=true`;
        return this.dataService.getRequest(secondPath);
      } else {
        this.spinnerService.hide();
        this.router.navigate(['creditorhome']);
        return []; // Return empty observable to satisfy mergeMap
      }
    }),
    tap((broadcastProxyDetails: any[]) => {
      if (broadcastProxyDetails && broadcastProxyDetails.length) {
        this.broadcastProxyDetails = broadcastProxyDetails;
        this.showProxyButton = broadcastProxyDetails.find(x => x.id.toLowerCase() == this.id.toLowerCase());
        this.isLoading = false;
      }
      this.spinnerService.hide();
    })
  ).subscribe();
}


  downloadSingleFile(file) {
    this.uploadService.downloadFile(file.name, file.id)
    
  }  

  async downloadAllFiles() {
    for (var i = 0; i < this.originalFiles.length; i++) {
      try {
        await this.uploadService.downloadFile(this.originalFiles[i].name, this.originalFiles[i].id);
        await new Promise(resolve => setTimeout(resolve, 300)); // Optional delay
      } catch (error) {
        console.warn(`Download failed for ${this.originalFiles[i].name}`);
      }
    }
  }
  listofDocuments() {
    this.originalFiles = [];
    for (const item of this.broadcastDetails.broadcastRecepientSupportingDocs) {
      if ((item.originalFileName !== null && item.filePath !== null))
        var fileExt = item.originalFileName.substr(item.originalFileName.lastIndexOf('.') + 1)               
      this.originalFiles.push({ id: item.originalFileName, name: item.filePath, fileSize: item.fileSize, extn: fileExt});
      
    }
    for (const item of this.broadcastDetails.broadcastSupportingDocs) {
      if ((item.originalFileName !== null && item.filePath !== null))
        var fileExt = item.originalFileName.substr(item.originalFileName.lastIndexOf('.') + 1)
      this.originalFiles.push({ id: item.originalFileName, name: item.filePath, fileSize: item.fileSize, extn: fileExt});

    }
    //Launch is replaced to download because of the requirement
    this.isnotonlyPDF = 'Download All';
    this.originalFiles.forEach( file=>{
      if(this.getMimetype(file.name.substring(file.name.lastIndexOf('.'))) != 'application/pdf' && this.getMimetype(file.name.substring(file.name.lastIndexOf('.'))) != 'image/gif' && this.getMimetype(file.name.substring(file.name.lastIndexOf('.'))) != 'image/jpeg'){
        this.isnotonlyPDF = 'Download All';
        file.hyperlink = 'Download'
      }
      else file.hyperlink = 'Download';
    })
  }
  public navigateToCreditorHome() {
    this.router.navigate(['creditorhome', { isBack: "back" }])
  }

  public redirectToProxyForm(){
    const data ={engagementName:this.activatedRoute.snapshot.paramMap.get('displayName'),engagementId :this.broadcastDetails.engagementId,creditorId:this.creditorId,podId:this.particularsOfDebtId,engagementNameDesc:this.activatedRoute.snapshot.paramMap.get('suffix'),creditorName:this.creditorName};
    const url = `/adjudication-proxyform-screen?engagementName=${data.engagementName}&engagementId=${data.engagementId}&creditorId=${data.creditorId}&podId=${data.podId}&engagementNameDesc=${data.engagementNameDesc}&creditorName=${data.creditorName}&isFormBroadcast=${false}`;
    window.open(url, '_blank');
  }

  private getMimetype(extension) {
    let mimetype;
    switch (extension) {
      case '.gif':
        mimetype = 'image/gif';
        break;
      case '.jpeg':
      case '.jpg':
        mimetype = 'image/jpeg';
        break;
      case '.heic':
        mimetype = 'image/heic';
        break;
      case '.xls':
        mimetype = 'application/vnd.ms-excel';
        break;
      case '.pptx':
        mimetype =
          'application/vnd.openxmlformats-officedocument.presentationml.presentation';
        break;
      case '.xlsx':
        mimetype =
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        break;
      case '.docx':
        mimetype =
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        break;
      case '.dotx':
        mimetype =
          'application/vnd.openxmlformats-officedocument.wordprocessingml.template';
        break;
      case '.ppt':
        mimetype = 'application/vnd.ms-powerpoint';
        break;
      case '.pptm':
        mimetype = 'application/vnd.ms-powerpoint.presentation.macroenabled.12';
        break;
      case '.doc':
        mimetype = 'application/msword';
        break;
      case '.pdf':
        mimetype = 'application/pdf';
        break;
      default:
        break;
    }

    if (mimetype) {
      return mimetype;
    }
  }
}
